import { render } from "./ErrorDisplay.vue?vue&type=template&id=5119e934&scoped=true&ts=true"
import script from "./ErrorDisplay.vue?vue&type=script&lang=ts"
export * from "./ErrorDisplay.vue?vue&type=script&lang=ts"

import "./ErrorDisplay.vue?vue&type=style&index=0&id=5119e934&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5119e934"]])

export default __exports__